import { backPackEventMap } from "../../config/BackpackEventConfig";
import { NormalBackpackI, normalBackPackSaveI } from "../../manager/DefineInterface";

const {ccclass, property} = cc._decorator;

@ccclass
export default class backpackBtnLayout extends cc.Component {

    backItem:normalBackPackSaveI = null;

    itemConfig: NormalBackpackI = null;

    @property({type:cc.Node,displayName:"btnLayout"})
    btnLayout:cc.Node = null;

    bindData(backItem:normalBackPackSaveI){
        this.backItem = backItem;
        this.itemConfig = backPackEventMap()[this.backItem.backId];
        let useAry:number[] = this.itemConfig.interactionType;
        let nameAry:string[] = this.itemConfig.interactionName;
        this.btnLayout.children.forEach((n:cc.Node,index:number)=>{
            if(useAry[index]!=null){
                n.active = true;
                let Label = n.getChildByName("label").getComponent(cc.Label);
                let str = nameAry[index];
                if(!str){
                    switch(useAry[index]){
                        case 0:{
                            str = "出售";
                            break;
                        }
                        case 1:{
                            str = "使用";
                            break;
                        }
                        case 2:{
                            str = "赠送";
                            break;
                        }
                    }
                }
                Label.string = str;
            }else{
                n.active = false;
            }
        });
        this.showAni();
    }
    
    showAni(){
        this.node.height = 0;
        cc.tween(this.node).to(0.2,{height:160}).start();    
    }

    hideAni(){
        cc.tween(this.node).to(0.2,{height:0}).start();
    }

}
